var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"declare-wrap"},[_c('el-container',[_c('el-header',[_c('AppHeader')],1),_c('el-container',{staticStyle:{"overflow":"auto"}},[_c('el-aside',{attrs:{"width":"202px"}},[_c('AppAside')],1),_c('el-main',[_c('keep-alive',[_c('router-view',{key:_vm.$route.path})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }